import {
  fetchUnavailableCodes,
  setAgentState as setAgentStateSdk,
} from '../../../../services/cxone-sdk.service';
import { logger } from '../../../../utils/logger';
import { UnavailableCode } from '../../../../types';
import { CXoneEventsSubscriptionContext } from '../../subscription-context';

let agentStateInitTimeoutId: ReturnType<typeof setTimeout> | null = null;
let unavailableStateApiRequested = false;

export function cancelAgentStateInitialization(): void {
  if (agentStateInitTimeoutId !== null) {
    clearTimeout(agentStateInitTimeoutId);
    agentStateInitTimeoutId = null;
  }
}

export function resetAgentStateInitialization(): void {
  cancelAgentStateInitialization();
  unavailableStateApiRequested = false;
}

export function fetchInitialUnavailableCodes(ctx: CXoneEventsSubscriptionContext): void {
  fetchUnavailableCodes()
    .then((codes: UnavailableCode[]) => {
      if (codes.length > 0) {
        ctx.unavailableCodesRef.current = codes;
        ctx.setUnavailableCodes(codes);
      }
    })
    .catch((error: unknown) => {
      logger.warn('[Events] Failed to fetch unavailable codes:', error);
    });
}

export function initializeAgentState(ctx: CXoneEventsSubscriptionContext): void {
  if (unavailableStateApiRequested || agentStateInitTimeoutId !== null) {
    return;
  }

  agentStateInitTimeoutId = setTimeout(() => {
    agentStateInitTimeoutId = null;

    if (unavailableStateApiRequested) {
      return;
    }

    ctx.setAgentStateInternal((currentState) => {
      if (currentState.state !== 'Unknown') {
        return currentState;
      }

      unavailableStateApiRequested = true;

      setAgentStateSdk('Unavailable')
        .then(() => {
          ctx.setAgentStateInternal({
            state: 'Unavailable',
            reason: null,
            reasonCode: null,
            stateStartTime: new Date(),
          });
        })
        .catch(() => {
          ctx.setAgentStateInternal({
            state: 'Unavailable',
            reason: null,
            reasonCode: null,
            stateStartTime: new Date(),
          });
        });

      return currentState;
    });
  }, 1500);
}
